import * as FormControl from '../utils/form-controls';
import * as CONST from '../utils/constants';

// global window
const filterObj = CONST.globalProject.StoryFilters;

// initial state
// object name must match specification name
const filters = {
};

if (filterObj && filterObj.find(x => x.Specification === 'PublishAfter')) {
    // add date range filter
    filters.PublishBefore = new FormControl.FilterGroup('PublishBefore', 'Published Before', null, null, false, true, 'date');
    filters.PublishAfter = new FormControl.FilterGroup('PublishAfter', 'Published After', null, null, false, true, 'date');
}

FormControl.assignFilters(filterObj, filters);

export { filters as default };